<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('o1')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="search">
                <div class="searchleft">
                    <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                        <el-form-item :label="$t('phone')">
                            <el-input v-model="searchform.phone" @keyup.enter.native="onSubmit" size="small" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('mchOrderNo')">
                            <el-input v-model="searchform.mchOrderNo" @keyup.enter.native="onSubmit" size="small" style="width:166px;"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('type')">
                            <el-select v-model="searchform.statusValue" style="width:120px;">
                                <el-option :label="$t('buxian')" :value="null"></el-option>
                                <el-option :label="$t('loan4')" :value="0"></el-option>
                                <el-option :label="$t('loan5')" :value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="App">
                            <el-select size="small" v-model="searchform.app" filterable @change="onAppChange" :placeholder="$t('qxz')" style="width:150px">
                                <el-option :label="$t('buxian')" :value="null"></el-option>
                                <el-option v-for="item in appChannelList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('pingt')">
                            <el-select size="small" v-model="searchform.platform" filterable :disabled="subProductChannelList.length === 0" :placeholder="$t('qxz')" style="width:150px">
                                <el-option :label="$t('buxian')" :value="null"></el-option>
                                <el-option
                                    v-for="item in subProductChannelList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="info" plain @click="openAllLink">{{$t('linkOpen')}}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <el-table :data="list" @current-change="handleCurrentChange" 
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="mchOrderNo" :label="$t('mchOrderNo')"></el-table-column>
                        <el-table-column prop="cantidad" :label="$t('cantidad')"></el-table-column>
                        <!-- <el-table-column prop="phone" :label="$t('phone')"></el-table-column> -->
                        <el-table-column prop="phone" :label="$t('phone')">
                            <template slot-scope="scope">
                                <el-link type="primary" @click="dial(scope.row.phone,0)">
                                    {{scope.row.phone}}
                                </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column prop="platform" :label="$t('pingt')"></el-table-column>
                        <el-table-column prop="statusValue" :label="$t('status')" width="100">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.statusValue == 0" type="info">{{$t('loan4')}}</el-tag>
                                <el-tag v-if="scope.row.statusValue == 1" type="info">{{$t('loan5')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="160" fixed="right">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" :content="$t('c14')" placement="top">
                                     <el-button size="small" @click="openadd(scope.row)" type="primary" icon="el-icon-circle-check" circle plain></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" :content="$t('c15')" placement="top">
                                     <el-button size="small" @click="portrait(scope.row)" type="primary" icon="el-icon-s-custom" circle plain></el-button>
                                </el-tooltip>
                                <el-popconfirm :title="$t('c16')" @confirm="addBlacklist(scope.row)" style="margin-left: 10px;">
                                    <el-button size="small" type="warning" icon="el-icon-circle-plus" circle slot="reference" plain></el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
                <div class="listleft">
                    <el-tabs type="border-card">
                        <el-tab-pane :label="$t('jbxx')">
                            <div class="orderdiv">
                                <div class="formbox" style="width:750px;">
                                    <h2 style="margin-bottom:12px;">{{$t('ddxq')}}</h2>
                                    <el-form ref="form" :model="orderForm" label-width="160px">
                                        <el-form-item :label="$t('phone')">
                                            <el-input v-model="orderForm.phone" style="width:130px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('mchOrderNo')" style="margin-left: 300px;margin-top: -60px;">
                                            <el-input v-model="orderForm.mchOrderNo" style="width:140px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('email')">
                                            <el-input v-model="orderForm.email" style="width:160px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('userName')" style="margin-left: 260px;margin-top: -60px;">
                                            <el-input v-model="orderForm.userName" style="width:160px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('cantidad')">
                                            <el-input v-model="orderForm.cantidad" style="width:130px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('days')" style="margin-left: 300px;margin-top: -60px;">
                                            <el-input v-model="orderForm.days" style="width:130px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('overdueDay')">
                                            <el-input v-model="orderForm.overdueDay" style="width:130px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('expireTime')" style="margin-left: 300px;margin-top: -60px;">
                                            <el-input v-model="orderForm.expireTime" style="width:130px;" :disabled="true" ></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('stats')">
                                            <el-input v-model="orderForm.stats" style="width:130px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('exclusiveLinks')" style="margin-left: 260px;margin-top: -60px;">
                                            <el-input v-model="orderForm.exclusiveLinks" style="width:130px;" :disabled="true"></el-input>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                            <div class="orderdiv" style="margin-top: 8px;">
                                <el-tabs type="border-card">
                                    <el-tab-pane :label="$t('gzxx')">
                                        <div class="formbox" style="width:750px;">
                                            <el-form ref="form" :model="form" label-width="180px">
                                               <el-form-item :label="$t('educationName')">
                                                    <el-input v-model="form.educationName" style="width:160px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('employmentName')" style="margin-left: 320px;margin-top: -62px;">
                                                    <el-input v-model="form.employmentName" style="width:160px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('comoanyName')">
                                                    <el-input v-model="form.comoanyName" style="width:160px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('comoanyPhone')" style="margin-left: 340px;margin-top: -62px;">
                                                    <el-input v-model="form.comoanyPhone" style="width:160px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('workingYearName')">
                                                    <el-input v-model="form.workingYearName" style="width:130px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('monthlySalaryName')" style="margin-left: 320px;margin-top: -62px;">
                                                    <el-input v-model="form.monthlySalaryName" style="width:130px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('workingDaysName')">
                                                    <el-input v-model="form.workingDaysName" style="width:130px;" :disabled="true"></el-input>
                                                </el-form-item>
                                            </el-form>
                                        </div>
                                    </el-tab-pane>
                                    <el-tab-pane :label="$t('jjlxr')">
                                        <div class="formbox" style="width:750px;">
                                            <el-form ref="form" :model="contactform" label-width="170px">
                                                <el-form-item :label="$t('lxr1xm')">
                                                    <el-input v-model="contactform.oneName" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('lxr2xm')" style="margin-left: 360px;margin-top: -62px;">
                                                    <el-input v-model="contactform.twoName" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('lxr1dh')">
                                                    <el-input v-model="contactform.onePhone" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('lxr2dh')" style="margin-left: 360px;margin-top: -62px;">
                                                    <el-input v-model="contactform.twoPhone" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('lxr1gx')">
                                                    <el-input v-model="contactform.oneType" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('lxr2gx')" style="margin-left: 360px;margin-top: -62px;">
                                                    <el-input v-model="contactform.twoType" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>
                                            </el-form>
                                        </div>
                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                            <div class="orderdiv" style="margin-top: 8px;">
                                <div class="formbox" style="width:750px;">
                                    <h2 style="margin-bottom:10px;">{{$t('sfxx')}}</h2>
                                    <el-form ref="form" :model="form" label-width="130px">
                                        <el-form-item :label="$t('idCardPositive')">
                                            <div class="block">
                                                <el-image :src="form.idCardPositive">
                                                <div slot="placeholder" class="image-slot">
                                                    {{$t('jzz')}}<span class="dot">...</span>
                                                </div>
                                                </el-image>
                                            </div>
                                        </el-form-item>
                                        <el-form-item :label="$t('idCardReverse')">
                                            <div class="block">
                                                <el-image :src="form.idCardReverse">
                                                <div slot="placeholder" class="image-slot">
                                                    {{$t('jzz')}}<span class="dot">...</span>
                                                </div>
                                                </el-image>
                                            </div>
                                        </el-form-item>
                                        <el-form-item :label="$t('faceUrl')">
                                            <div class="block">
                                                <el-image :src="form.faceUrl">
                                                <div slot="placeholder" class="image-slot">
                                                    {{$t('jzz')}}<span class="dot">...</span>
                                                </div>
                                                </el-image>
                                            </div>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('txl')">
                            <div class="search">
                                <el-form :inline="true" :model="searchform1" class="demo-form-inline" @submit.native.prevent >
                                    <el-form-item :label="$t('phone')">
                                        <el-input v-model="searchform1.phone" style="width: 150px;" @keyup.enter.native="txlonSubmit" size="small"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button size="small" type="primary" @click="txlonSubmit">{{$t('query')}}</el-button>
                                    </el-form-item>
                                    <el-button type="success" v-if="this.cardFirst != null" @click="cf">Qaa1：{{cardFirst}}</el-button>
                                    <el-button type="success" v-if="this.cardSecond != null" @click="cs">Qaa2：{{cardSecond}}</el-button>
                                </el-form>
                            </div>
                            <div class="orderdiv">
                                <div class="formbox" style="width:780px;margin-top: -15px;" v-loading="txlloading">
                                    <template>
                                        <el-table :data="ctList"
                                            :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                            <el-table-column :label="$t('txl')" style="background-color:#550000">
                                                <!-- <el-table-column prop="phone" :label="$t('phone')"></el-table-column> -->
                                                <el-table-column prop="phone" :label="$t('phone')">
                                                    <template slot-scope="scope">
                                                        <el-link type="primary" @click="dial(scope.row.phone,1)">
                                                            {{scope.row.phone}}
                                                        </el-link>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="name" :label="$t('name')"></el-table-column>
                                                <el-table-column prop="concern" :label="$t('guanxi')">
                                                    <template slot-scope="scope">
                                                        <el-tag v-if="scope.row.concern=='家庭'" type="primary">{{$t('txl1')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern=='普通'" type="info">{{$t('txl2')}}</el-tag>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="type" :label="$t('jjlxr')"></el-table-column>
                                            </el-table-column>
                                        </el-table>
                                        <div class="page">
                                            <app-page :total="ctTotal" :current="ctPageNo" :pageSize="ctPageSize"
                                                @handleCurrentChange="ctCurrentchange" @handleSizeChange="ctHandchange"></app-page>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('o2')">
                            <div class="orderdiv" style="margin-top: 8px;">
                                <template>
                                    <el-form ref="form" :model="checkForm" style="width: 400px;">
                                        <el-form-item :label="$t('c1')" style="margin-left: 10px;">
                                            <template slot-scope="scope">
                                                <el-tag v-if="checkForm.va1==1" type="primary">si</el-tag>
                                                <el-tag v-if="checkForm.va1==2" type="info">no</el-tag>
                                            </template>
                                        </el-form-item>
                                        <el-form-item :label="$t('c2')" style="margin-left: 10px;">
                                            <template slot-scope="scope">
                                                <el-tag v-if="checkForm.va2==1" type="primary">si</el-tag>
                                                <el-tag v-if="checkForm.va2==2" type="info">no</el-tag>
                                            </template>
                                        </el-form-item>
                                        <el-form-item :label="$t('c3')" style="margin-left: 10px;">
                                            <template slot-scope="scope">
                                                <el-tag v-if="checkForm.va3==1" type="primary">si</el-tag>
                                                <el-tag v-if="checkForm.va3==2" type="info">no</el-tag>
                                            </template>
                                        </el-form-item>
                                        <el-form-item :label="$t('c4')" style="margin-left: 10px;">
                                            <template slot-scope="scope">
                                                <el-tag v-if="checkForm.va4==1" type="primary">si</el-tag>
                                                <el-tag v-if="checkForm.va4==2" type="info">no</el-tag>
                                            </template>
                                        </el-form-item>
                                        <el-form-item :label="$t('c5')" style="margin-left: 10px;">
                                            <template slot-scope="scope">
                                                <el-tag v-if="checkForm.va5==1" type="primary">si</el-tag>
                                                <el-tag v-if="checkForm.va5==2" type="info">no</el-tag>
                                            </template>
                                        </el-form-item>
                                        <el-form-item :label="$t('c6')" style="margin-left: 10px;">
                                            <template slot-scope="scope">
                                                <el-tag v-if="checkForm.va6==1" type="primary">si</el-tag>
                                                <el-tag v-if="checkForm.va6==2" type="info">no</el-tag>
                                            </template>
                                        </el-form-item>
                                        <el-form-item :label="$t('c7')" style="margin-left: 10px;">
                                            <template slot-scope="scope">
                                                <el-tag v-if="checkForm.va7==1" type="primary">si</el-tag>
                                                <el-tag v-if="checkForm.va7==2" type="info">no</el-tag>
                                            </template>
                                        </el-form-item>
                                        <el-form-item :label="$t('c8')" style="margin-left: 10px;">
                                            <template slot-scope="scope">
                                                <el-tag v-if="checkForm.va8==1" type="primary">si</el-tag>
                                                <el-tag v-if="checkForm.va8==2" type="info">no</el-tag>
                                            </template>
                                        </el-form-item>
                                        <el-form-item :label="$t('c9')" style="margin-left: 10px;">
                                            <template slot-scope="scope">
                                                <el-tag v-if="checkForm.va9==1" type="primary">si</el-tag>
                                                <el-tag v-if="checkForm.va9==2" type="info">no</el-tag>
                                            </template>
                                        </el-form-item>
                                        <el-form-item :label="$t('c10')" style="margin-left: 10px;">
                                            <template slot-scope="scope">
                                                <el-tag v-if="checkForm.va10==1" type="primary">si</el-tag>
                                                <el-tag v-if="checkForm.va10==2" type="info">no</el-tag>
                                            </template>
                                        </el-form-item>
                                    </el-form>
                                </template>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
        <pop-up :title="$t('o4')" :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box" class="addCss">
                <el-form ref="form" :inline="true" :model="checkForm" :rules="rules" size="small" label-width="120px">
                    <el-radio-group v-model="checkForm.resource">
                        <el-radio :label="1">{{$t('o5')}}</el-radio>
                        <el-radio :label="2">{{$t('o6')}}</el-radio>
                    </el-radio-group>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    phone: null,
                    mchOrderNo: null,
                    email: null,
                    userName: null,
                    cantidad: null,
                    days: null,
                    overdueDay: null,
                    expireTime: null,
                    createTime: null,
                    exclusiveLinks:null,
                    stats: null
                },
                orderForm:{
                    phone: null,
                    mchOrderNo: null,
                    email: null,
                    userName: null,
                    cantidad: null,
                    days: null,
                    overdueDay: null,
                    expireTime: null,
                    createTime: null,
                    exclusiveLinks:null,
                    stats: null
                },
                contactform:{
                    onePhone:null,
                    oneName:null,
                    oneType:null,
                    twoPhone:null,
                    twoName:null,
                    twoType:null
                },
                checkForm: {
                    orderId: null,
                    resource: null,
                    va1: null,
                    va2: null,
                    va3: null,
                    va4: null,
                    va5: null,
                    va6: null,
                    va7: null,
                    va8: null,
                    va9: null,
                    va10: null,
                },
                searchform: {
                    blurry: "",
                },
                searchform1: {
                    phone: "",
                },
                defaultProps: {
                    label: "name",
                    isLeaf: 'isLeaf'
                },
                loading: false,
                txlloading: false,
                loanLoading:false,
                homeLoading:false,
                showadd: false,
                list: [],
                value1:[],
                searchform:{
                    platform: null,
                },
                searchform1:{},
                total: 1,
                pageNo: 1,
                pageSize: 10,
                loanTotal: 1,
                loanPageNo: 1,
                loanPageSize: 5,
                ctTotal: 1,
                ctPageNo: 1,
                ctPageSize: 10,
                total1: 1,
                pageNo1: 1,
                pageSize1: 10,
                smsTotal: 1,
                smsPageNo: 1,
                smsPageSize: 5,
                repTotal: 1,
                repPageNo: 1,
                repPageSize: 10,
                keyword: '',
                user:null,
                rolelist: [],
                status: null,
                classlist: [],
                loanList:[],
                ctList:[],
                list1: [],
                smsList:[],
                repList:[],
                currentRow: null,
                orderDeId:null,
                principallist1:[],
                accountlist: [],
                cardFirst: null,
                cardSecond: null,
                appChannelList: [],
                subProductChannelList: [],
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
            this.getAppChannel()
        },
        methods: {
            onAppChange(val) {
                this.searchform.platform=null
                if (val === null) {
                    this.subProductChannelList=[]
                } else {
                    this.getSubProductChannel();
                }
            },
            openAllLink(){
                var encodeData1 = window.btoa(window.encodeURIComponent("userId=" + this.user.user.id + "&userName=" + this.user.user.username + "&temp=" + new Date().getTime()));
                for (let i = 0; i < this.list.length; i++) {
                    window.open('http://hx2.easylend.live/#/UserPortrait?phone=' + this.list[i].mchOrderNo + "&userId=" + encodeData1);
                };
            },
            dial(row, row1) {
                alert(row)
                _api.get(apiurl.dial, {
                    phone : row,
                    type : row1,
                    nation : localStorage.getItem("nation"),
                }).then(res => {
                    alert(res.message);
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    })
                })
            },
            getAppChannel() {
                _api.get(apiurl.appChannel, {
                }).then(res => {
                    this.appChannelList = res.data
                })
            },
            getSubProductChannel() {
                _api.get(apiurl.subProductChannel, {
                    app: this.searchform.app
                }).then(res => {
                    this.subProductChannelList = res.data
                })
            },
            addBlacklist(row) {
                _api.delete(apiurl.addBlacklist, row.userId)
                .then(res => {
                    this.$notify({
                        title: this.$t('success'),
                        message: this.$t('addSuccess'),
                        type: 'success'
                    });
                    this.pageNo = 1
                    this.getList()
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    });
                })
            },
            portrait(row) {
                var encodeData = window.btoa(window.encodeURIComponent(
                    "userId=" + this.user.user.id + "&userName=" + this.user.user.username 
                    + "&temp=" + new Date().getTime()));
                window.open('http://hx.easylend.live/#/UserPortrait?phone=' + row.mchOrderNo + "&userId=" + encodeData);
            },
            openadd(row) {
                this.orderDeId = row.id;
                this.showadd = true
                this.checkForm = {
                    resource: null,
                    orderId: row.id,
                    userId:this.user.user.id,
                    userName:this.user.user.username,
                    mchOrderNo:row.mchOrderNo
                }
            },
            getaccount() {
                _api.get(apiurl.accountBook, {
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.accountlist = res.data
                })
            },
            handleCurrentChange(val) {
                this.currentRow = val.userId;
                this.orderDeId = val.id;
                this.getDetail();
                this.getOrderDetail();
                this.getContactDetail();
                this.getCtList();
                this.getCheckDetail()
            },
            getprincipal1() {
                _api.get(apiurl.users, {
                    roleId: 3,
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.principallist1 = res.content
                })
            },
            getCheckDetail(){
                _api.get(apiurl.check,{
                    userId:this.currentRow
                }).then(res=>{
                    this.checkForm.remark=res.data.remark
                    this.checkForm.va1=res.data.va1
                    this.checkForm.va2=res.data.va2
                    this.checkForm.va3=res.data.va3
                    this.checkForm.va4=res.data.va4
                    this.checkForm.va5=res.data.va5
                    this.checkForm.va6=res.data.va6
                    this.checkForm.va7=res.data.va7
                    this.checkForm.va8=res.data.va8
                    this.checkForm.va9=res.data.va9
                    this.checkForm.va10=res.data.va10
                })
            },
            getclass() {
                _api.get(apiurl.classifyAll, {
                }).then(res => {
                    this.classlist = res.data
                })
            },
            getconfirm() {
                _api.post(apiurl.loanPay, this.checkForm)
                .then(res => {
                    this.$notify.success({
                        title: this.$t('success'),
                        message: this.$t('czcg'),
                    })
                    this.getList()
                    this.showadd = false
                    this.checkForm = {
                        resource: null,
                        orderId: row.id,
                        userId:this.user.user.id,
                        userName:this.user.user.username,
                        orderNo:row.mchOrderNo
                    }
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    })
                })
            },
            getList() {
                this.loading = true
                _api.get(apiurl.checkorder, {
                    page: this.pageNo,
                    size: this.pageSize,
                    phone: this.searchform.phone,
                    mchOrderNo: this.searchform.mchOrderNo,
                    type: this.searchform.statusValue,
                    nation:localStorage.getItem("nation"),
                    platform: this.searchform.platform,
                    app: this.searchform.app,
                }).then(res => {
                    this.loading = false
                    this.list = res.data.list
                    this.total = res.data.total
                })
            },
            getCtList() {
                this.txlloading = true,
                _api.get(apiurl.userContact, {
                    page: this.ctPageNo,
                    size: this.ctPageSize,
                    nation:localStorage.getItem("nation"),
                    blurry:this.searchform1.phone,
                    userId: this.currentRow,
                }).then(res => {
                    this.ctList = res.data.data
                    this.ctTotal = res.data.totalCount
                    this.txlloading = false
                })
            },
            getLoanList() {
                this.loanLoading = true
                _api.get(apiurl.myOrderRecord, {
                    page: this.loanPageNo,
                    size: this.loanPageSize,
                    nation:localStorage.getItem("nation"),
                    userId: this.currentRow
                }).then(res => {
                    this.loanLoading = false
                    this.loanList = res.data.list
                    this.loanTotal = res.data.total
                })
            },
            getOrderDetail(){
                _api.get(apiurl.orderDetail,{
                    nation:localStorage.getItem("nation"),
                    orderId:this.orderDeId
                }).then(res=>{
                    this.orderForm.phone=res.data.phone
                    this.orderForm.mchOrderNo=res.data.mchOrderNo
                    this.orderForm.email=res.data.email
                    this.orderForm.userName=res.data.userName
                    this.orderForm.cantidad=res.data.cantidad
                    this.orderForm.days=res.data.days
                    this.orderForm.overdueDay=res.data.overdueDay
                    this.orderForm.expireTime=res.data.expireTime
                    this.orderForm.createTime=res.data.createTime
                    this.orderForm.exclusiveLinks=res.data.exclusiveLinks
                    this.orderForm.stats=res.data.stats
                    this.cardFirst=res.data.cardFirst
                    this.cardSecond=res.data.cardSecond
                })
            },
            getContactDetail(){
                _api.get(apiurl.contactInfo,{
                    userId:this.currentRow
                }).then(res=>{
                    this.contactform.onePhone=res.data.onePhone
                    this.contactform.oneName=res.data.oneName
                    this.contactform.oneType=res.data.oneType
                    this.contactform.twoPhone=res.data.twoPhone
                    this.contactform.twoName=res.data.twoName
                    this.contactform.twoType=res.data.twoType
                })
            },
            getDetail(){
                _api.get(apiurl.userInfo,{userId:this.currentRow}).then(res=>{
                    this.form.birthday=res.data.birthday
                    this.form.addressAll=res.data.addressAll
                    this.form.gender=res.data.gender
                    this.form.fatherLastName=res.data.fatherLastName
                    this.form.motherLastName=res.data.motherLastName
                    this.form.postalCode=res.data.postalCode
                    this.form.fullName=res.data.fullName
                    this.form.idNumber=res.data.idNumber
                    this.form.district=res.data.district
                    this.form.email=res.data.email
                    this.form.educationName=res.data.educationName
                    this.form.employmentName=res.data.employmentName
                    this.form.comoanyName=res.data.comoanyName
                    this.form.comoanyPhone=res.data.comoanyPhone
                    this.form.workingYearName=res.data.workingYearName
                    this.form.monthlySalaryName=res.data.monthlySalaryName
                    this.form.workingDaysName=res.data.workingDaysName
                    this.form.idCardPositive=res.data.idCardPositive
                    this.form.idCardReverse=res.data.idCardReverse
                    this.form.faceUrl=res.data.faceUrl
                })
            },
            getHomeTotal(){
                this.homeLoading = true
                _api.get(apiurl.callTotal,{
                    nation:localStorage.getItem("nation"),
                })
                .then(res=>{
                    this.homeLoading = false
                    this.homeTotal.callNum=res.data.callNum
                    this.homeTotal.recall=res.data.recall
                    this.homeTotal.recallRate=res.data.recallRate
                    this.homeTotal.callMoney=res.data.callMoney
                    this.homeTotal.recallMoney=res.data.recallMoney
                })
            },
            getList1() {
                _api.get(apiurl.callInfo, {
                    page: this.pageNo1,
                    size: this.pageSize1,
                    orderId: this.orderDeId
                }).then(res => {
                    this.list1 = res.data.list
                    this.total1 = res.data.total
                })
            },
            getSmsList(){
                _api.get(apiurl.sysNews, {
                    page: this.smsPageNo,
                    size: this.smsPageSize,
                    userId:this.currentRow
                }).then(res => {
                    this.smsList = res.data.list
                    this.smsTotal = res.data.total
                })
            },
            getRepList(){
                _api.get(apiurl.repayment, {
                    page: this.repPageNo,
                    size: this.repPageSize,
                    userId:this.currentRow
                }).then(res => {
                    this.repList = res.data.list
                    this.repTotal = res.data.total
                })
            },
            cf() {
                this.dial(this.cardFirst,0)
            },
            cs() {
                this.dial(this.cardSecond,0)
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            txlonSubmit() {
                this.ctPageNo = 1
                this.getCtList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
            loanHandchange(data) { //分页Size变化
                this.loanPageSize = data
                this.loanPageNo = 1
                this.getLoanList()
            },
            loanCurrentchange(data) { //当前页变化
                this.loanPageNo = data
                this.getLoanList()
            },
            ctHandchange(data) { //分页Size变化
                this.ctPageSize = data
                this.ctPageNo = 1
                this.getCtList()
            },
            ctCurrentchange(data) { //当前页变化
                this.ctPageNo = data
                this.getCtList()
            },
            handchange1(data) { //分页Size变化
                this.pageSize1 = data
                this.pageNo1 = 1
                this.getList1()
            },
            currentchange1(data) { //当前页变化
                this.pageNo1 = data
                this.getList1()
            },
            smsHandchange(data) { //分页Size变化
                this.smsPageSize = data
                this.smsPageNo = 1
                this.getSmsList()
            },
            smsCurrentchange(data) { //当前页变化
                this.smsPageNo = data
                this.getSmsList()
            },
            repHandchange(data) { //分页Size变化
                this.repPageSize = data
                this.repPageNo = 1
                this.getRepList()
            },
            repCurrentchange(data) { //当前页变化
                this.repPageNo = data
                this.getRepList()
            },
        }
    }
</script>
<style scoped>
    
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .orderdiv{
        display: flex;
        border-style: ridge;
        border-bottom: 1px solid #EBEEF5;
    }

    .listleft {
        width: 50%;
        margin-left: 0.5%;
    }

    body .el-table th.gutter{
        display: table-cell!important;
    }

    .listright {
        width: 50%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }
    .formbox{ padding:15px 0; margin-top: 10px;}

    .listrighttop span {
        float: right;
    }
    .toptj{ display: flex; margin:15px 0;}
    .tjitem{ 
        flex: 1; 
        background: #ffffff; 
        cursor: pointer; 
        border: #ebedf0 solid 1px; 
        height: 60px; 
        margin-right: 10px;
        padding: 8px 12px;
        text-align: center;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>